import { useEffect, useState } from 'react'

/** Is a super-admin viewing the app as this user? (Set by the impersonation exchange, cleared when it ends.) */
export function isViewingAsAnotherUser(): boolean {
  try {
    return typeof window !== 'undefined' && window.sessionStorage.getItem('hf-app:is-impersonating') === 'true'
  } catch {
    return false
  }
}

/**
 * The same, as React state: false on the server and on the first render (so nothing differs at hydration), then the
 * stored answer. Screens for HumanFirewall's own staff render on it; the API refuses their data to everyone else
 * (@ImpersonationOnly), so the flag only decides what is drawn, never what is allowed.
 */
export function useViewingAsAnotherUser(): boolean {
  const [viewing, setViewing] = useState(false)
  useEffect(() => {
    setViewing(isViewingAsAnotherUser())
  }, [])
  return viewing
}
